<template>
  <div class="settle-wrap">
    <div class="loading-wrap" v-if="!pageLoaded">
      <i class="el-icon-loading"  />
    </div>
    <div v-else>
      <div class="settle-indexs">
        <div class="settle-index index-1" :class="currentIndex > 1 ? 'green-index' : ''">
          
          <div class="index-round">
            <p v-if="currentIndex === 1">1</p>
            <i v-else class="el-icon-check"></i>
          </div>
          <div class="index-text">入門測試</div>
        </div>
        <div class="settle-line line-1"></div>
        <div class="settle-index index-2" :class="currentIndex === 1 ? 'grey-index' : currentIndex === 2 ? '' : 'green-index'">
          <div class="index-round">
            <p v-if="currentIndex < 3">2</p>
            <i v-else class="el-icon-check"></i>
          </div>
          <div class="index-text">基礎資料</div>
        </div>
        <div class="settle-line line-2"></div>
        <div class="settle-index index-3" :class="currentIndex === 3 ? '' : 'grey-index'">
          <div class="index-round">3</div>
          <div class="index-text">資格審核</div>
        </div>
      </div>
      <div class="index-wrap">
        <Question
          v-if="currentIndex === 1"
          @toStep="toStep"
        />
        <Settle
          v-if="currentIndex === 2"
          @toStep="toStep"
        />
        <Checking
          v-if="currentIndex === 3"
        />
      </div>
    </div>
   
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Question from './question/index'
import Settle from './step-2'
import Checking from './step-3'
export default {
  components: {
    Question,
    Settle,
    Checking
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    return {
      currentIndex: 1,
      pageLoaded: false,
      isCheckingSkill: false,
    }
  },
  beforeRouteLeave(to,from,next) {
    if (this.adminAction || to.name === 'Login') {
      next()
      return
    }
    if(this.currentIndex === 1) {
      this.$confirm({
        title: '中途退出的話，此前的答題將會被清零哦，請慎重考慮',
        confirmButtonText: '繼續答題',
        cancelButtonText: '堅持退出',
        closeOnClickModal: false,
      }).then(()=>{
      }).catch(()=>{
        next()
      })
    } else if(this.currentIndex === 2){
      this.$confirm({
        content: '您已完成入門測試，退出仍保留答題通過的狀態，不一鼓作氣完成申請嗎！',
        title: '僅差一步嘍，確認要退出嗎？',
        confirmButtonText: '繼續填寫',
        cancelButtonText: '堅持退出',
        closeOnClickModal: false,
      }).then(()=>{
      }).catch(()=>{
        next()
      })
    } else {
      next()
    } 
  },
  created() {
    this.getSkillStatus()
  },
  methods: {
    toStep(step) {
      this.currentIndex = step
    },
    getSkillStatus() {
      if (this.userInfo.userKind === 'Player') {
        this.adminAction = true
        this.$router.replace({
          name: 'homepage'
        })
        return
      }
      this.$store.dispatch('app/getGamesList').then(({ allGames }) => {
        if (allGames) {
          this.pageLoaded = true
          for (var attr in allGames) {
            for (var i in allGames[attr]) {
              if (allGames[attr][i].status === 'Checking') {
                this.isCheckingSkill = true
                this.currentIndex = 3
                return
              }
            }
          }
          if (window.localStorage.getItem(this.userInfo.uuid + '_RATE') && parseInt(window.localStorage.getItem(this.userInfo.uuid + '_RATE')) > 89) {
            this.currentIndex = 2
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.settle-wrap {
  min-height: 500px;
  border-radius: 8px;
  margin: 50px auto 100px;
  .loading-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    height: 500px;
  }
  .settle-indexs {
    margin-top: 60px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .settle-index {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 27px;
      .index-round {
        width: 24px;
        height: 24px;
        background: #333333;
        border-radius: 100%;
        color: white;
        line-height: 24px;
        text-align: center;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .index-text {
        color: black;
      }
    }
    .settle-line {
      border-top: 1px dashed #999999;
      width: 72px;
      margin-right: 27px;
    }
    .green-index {
      .index-round {
        background: #5AB64E;
      }
    }
    .grey-index {
      .index-round {
        background: none;
        border: 2px solid #636D86;
        box-sizing: border-box;
        line-height: 20px;
        color: #636D86;
      }
      .index-text {
        color: #636D86;
      }
    }
  }
  
}
</style>